"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuList = void 0;
const interfaces_1 = require("./interfaces");
const mergeMenuSignaling_1 = require("./recorder/mergeMenuSignaling");
const extractPointsFromTciMode = (train) => {
    const tciEntries = train.Tci;
    if (!Array.isArray(tciEntries)) {
        return null;
    }
    for (const tciEntry of tciEntries) {
        if (!tciEntry || typeof tciEntry !== "object") {
            continue;
        }
        const modes = tciEntry.Mode;
        if (!Array.isArray(modes)) {
            continue;
        }
        for (const mode of modes) {
            if (!mode || typeof mode !== "object") {
                continue;
            }
            const points = mode.Points;
            if (Array.isArray(points) && points[0] && typeof points[0] === "object") {
                return points[0];
            }
        }
    }
    return null;
};
const normalizeTrainPoints = (train) => {
    const points = train.Points;
    if (Array.isArray(points) && points.length > 0) {
        return points;
    }
    if (points && typeof points === "object") {
        return [points];
    }
    const nestedPoint = extractPointsFromTciMode(train);
    if (nestedPoint) {
        return [nestedPoint];
    }
    if (train.AlarmStatus != null || train.PointStatus != null || train.VisualControlAlarmStatus != null) {
        return [
            {
                AlarmStatus: train.AlarmStatus,
                PointStatus: train.PointStatus,
                VisualControlAlarmStatus: train.VisualControlAlarmStatus,
            },
        ];
    }
    return [{}];
};
const normalizeMenuTrain = (train) => {
    const tciEntries = train.Tci;
    const firstTciEntry = Array.isArray(tciEntries) && tciEntries[0] && typeof tciEntries[0] === "object"
        ? tciEntries[0]
        : null;
    const firstModeEntry = firstTciEntry &&
        Array.isArray(firstTciEntry.Mode) &&
        firstTciEntry.Mode[0] &&
        typeof firstTciEntry.Mode[0] === "object"
        ? firstTciEntry.Mode[0]
        : null;
    const normalized = Object.assign(Object.assign({}, train), { Points: normalizeTrainPoints(train), TciValue: typeof train.TciValue === "number" && !Number.isNaN(train.TciValue)
            ? train.TciValue
            : typeof (firstTciEntry === null || firstTciEntry === void 0 ? void 0 : firstTciEntry.TciValue) === "number" && !Number.isNaN(firstTciEntry.TciValue)
                ? firstTciEntry.TciValue
                : train.TciValue, ModeColor: (typeof train.ModeColor === "string" && train.ModeColor) ||
            (typeof train.ModeColor === "number" && Number.isFinite(train.ModeColor) && String(train.ModeColor)) ||
            (typeof (firstModeEntry === null || firstModeEntry === void 0 ? void 0 : firstModeEntry.ModeColor) === "string" && firstModeEntry.ModeColor) ||
            (typeof (firstModeEntry === null || firstModeEntry === void 0 ? void 0 : firstModeEntry.ModeColor) === "number" &&
                Number.isFinite(firstModeEntry.ModeColor) &&
                String(firstModeEntry.ModeColor)) ||
            (typeof (firstModeEntry === null || firstModeEntry === void 0 ? void 0 : firstModeEntry.mc) === "string" && firstModeEntry.mc) ||
            (typeof (firstModeEntry === null || firstModeEntry === void 0 ? void 0 : firstModeEntry.mc) === "number" && Number.isFinite(firstModeEntry.mc) && String(firstModeEntry.mc)) ||
            train.ModeColor == null
            ? train.ModeColor
            : String(train.ModeColor), ModeChangedAt: (typeof train.ModeChangedAt === "string" && train.ModeChangedAt) ||
            (typeof (firstModeEntry === null || firstModeEntry === void 0 ? void 0 : firstModeEntry.ModeChangedAt) === "string" && firstModeEntry.ModeChangedAt) ||
            (typeof (firstModeEntry === null || firstModeEntry === void 0 ? void 0 : firstModeEntry.md) === "string" && firstModeEntry.md) ||
            train.ModeChangedAt, ldd: typeof train.ldd === "string" ? train.ldd : train.ldd == null ? null : String(train.ldd) });
    return normalized;
};
class MenuList {
    constructor(stations) {
        this.parents = [];
        this.parentsWithoutChildren = [];
        this.getDefaultList = () => {
            return [...this.parents];
        };
        this.filterItemsWithOtherStatuses = (items, criterias, considerVisualControlStatus) => {
            return items
                .map((_a) => {
                var { Trains, children } = _a, rest = __rest(_a, ["Trains", "children"]);
                const filteredTrains = Trains === null || Trains === void 0 ? void 0 : Trains.filter(({ Points }) => criterias.includes(this.getMaxAlarmStatus(Points, considerVisualControlStatus)));
                const filteredChildren = this.filterItemsWithOtherStatuses(children, criterias, considerVisualControlStatus);
                if (!filteredTrains.length && !filteredChildren.length) {
                    return null;
                }
                return Object.assign(Object.assign({}, rest), { Trains: filteredTrains, children: filteredChildren });
            })
                .filter(Boolean);
        };
        this.filterItemsByQuery = (items, query) => {
            return items
                .map((_a) => {
                var { Trains, children } = _a, rest = __rest(_a, ["Trains", "children"]);
                const filteredTrains = Trains === null || Trains === void 0 ? void 0 : Trains.filter(({ TrainName }) => TrainName === null || TrainName === void 0 ? void 0 : TrainName.includes(query));
                const filteredChildren = this.filterItemsByQuery(children, query);
                if (!filteredTrains.length && !filteredChildren.length) {
                    return null;
                }
                return Object.assign(Object.assign({}, rest), { Trains: filteredTrains, children: filteredChildren });
            })
                .filter(Boolean);
        };
        this.getListedStation = (list, stationId) => {
            let station = null;
            if (!list) {
                return null;
            }
            for (const item of list) {
                if (station) {
                    return station;
                }
                station = item.Id === stationId ? item : this.getListedStation(item.children, stationId);
            }
            return station;
        };
        this.getAllNestedTrains = (stationId) => {
            const allNestedTrains = {};
            const station = this.getListedStation(this.parents, stationId);
            let orderNumber = 0;
            const getNestedTrains = (item) => {
                return [
                    ...item.Trains.filter(({ TrainId }) => TrainId),
                    ...(item.children ? item.children.map(getNestedTrains).flat(2) : []),
                ];
            };
            if (station) {
                const nestedTrains = getNestedTrains(station);
                nestedTrains.forEach(item => {
                    if (item === null || item === void 0 ? void 0 : item.TrainId) {
                        allNestedTrains[item.TrainId] = {
                            orderNumber,
                        };
                        orderNumber += 1;
                    }
                });
            }
            return allNestedTrains;
        };
        /**
         * Filters menu tree items using the active train filters.
         *
         * @method
         * @param {IMenuTreeItem[]} items Tree nodes to filter.
         * @param {IFilterDto} filters Active train filters.
         * @param {FilterStatus} currentStatusFilter Current alarm-status filter.
         * @param {boolean} considerVisualControlStatus Whether visual-control alarm status should be used as a fallback.
         */
        this.filterItemsByFilters = (items, filters, currentStatusFilter, considerVisualControlStatus, preserveStationComputedState = false) => {
            const allNestedTrainsInPath = filters.path ? this.getAllNestedTrains(filters.path) : [];
            const statusFilteredItems = this.getItemsByStatusFilter(items, currentStatusFilter, considerVisualControlStatus, preserveStationComputedState);
            const filteredItems = this.filterItemsByTrainFilters(statusFilteredItems, filters, allNestedTrainsInPath);
            if (!preserveStationComputedState) {
                this.fillComputedState(filteredItems, considerVisualControlStatus);
            }
            return filteredItems;
        };
        this.buildFilteredList = (filters, currentStatusFilter, considerVisualControlStatus, preserveStationComputedState = false) => {
            const computedDefaultList = this.getListWithDefaultStatuses(this.getDefaultList(), considerVisualControlStatus);
            return this.filterItemsByFilters(computedDefaultList, filters, currentStatusFilter, considerVisualControlStatus, preserveStationComputedState);
        };
        this.getListWithDefaultStatuses = (items, considerVisualControlStatus) => {
            this.fillComputedState(items, considerVisualControlStatus);
            return items;
        };
        this.getListWithWarningStatuses = (items, considerVisualControlStatus, preserveStationComputedState = false) => {
            const parents = this.filterItemsWithOtherStatuses(items, [60, 90], considerVisualControlStatus);
            if (!preserveStationComputedState) {
                this.fillComputedState(parents, considerVisualControlStatus);
            }
            return parents;
        };
        this.getListWithNonWarningStatuses = (items, considerVisualControlStatus, preserveStationComputedState = false) => {
            const parents = this.filterItemsWithOtherStatuses(items, [0, 40, 45], considerVisualControlStatus);
            if (!preserveStationComputedState) {
                this.fillComputedState(parents, considerVisualControlStatus);
            }
            return parents;
        };
        this.getItemsByStatusFilter = (items, currentStatusFilter, considerVisualControlStatus, preserveStationComputedState) => {
            if (currentStatusFilter === interfaces_1.FilterStatus.nonWarning) {
                return this.getListWithNonWarningStatuses(items, considerVisualControlStatus, preserveStationComputedState);
            }
            if (currentStatusFilter === interfaces_1.FilterStatus.warning) {
                return this.getListWithWarningStatuses(items, considerVisualControlStatus, preserveStationComputedState);
            }
            return preserveStationComputedState ? items : this.getListWithDefaultStatuses(items, considerVisualControlStatus);
        };
        this.filterItemsByTrainFilters = (items, filters, allNestedTrainsInPath) => {
            return items
                .map((_a) => {
                var { Trains, children } = _a, rest = __rest(_a, ["Trains", "children"]);
                const filteredTrains = Trains === null || Trains === void 0 ? void 0 : Trains.filter(train => this.isTrainMatchingFilters(train, filters, allNestedTrainsInPath));
                const filteredChildren = this.filterItemsByTrainFilters(children, filters, allNestedTrainsInPath);
                if (!filteredTrains.length && !filteredChildren.length) {
                    return null;
                }
                return Object.assign(Object.assign({}, rest), { Trains: filteredTrains, children: filteredChildren });
            })
                .filter(Boolean);
        };
        this.isTrainMatchingFilters = (train, filters, allNestedTrainsInPath) => {
            const isPathMatch = !filters.path || (!!(train === null || train === void 0 ? void 0 : train.TrainId) && allNestedTrainsInPath[train.TrainId]);
            const isEquipmentGroupMatch = !filters.equipmentGroup || (!!train.idEquipmentGroup && train.idEquipmentGroup === filters.equipmentGroup);
            const isInstanceNumberMatch = !filters.instanceNumber ||
                (!!train.TrainInstanceNumber &&
                    train.TrainInstanceNumber.toLowerCase().includes(filters.instanceNumber.toLowerCase()));
            const isTrainNameMatch = !filters.trainName ||
                ("TrainName" in train &&
                    !!train.TrainName &&
                    train.TrainName.toLowerCase().includes(filters.trainName.toLowerCase()));
            const isManufacturerMatch = !filters.manufacturer || (!!train.idManufacturer && train.idManufacturer === filters.manufacturer);
            const isRFIDMatch = !filters.rfid || (!!train.TrainRFID && train.TrainRFID.toLowerCase().includes(filters.rfid.toLowerCase()));
            const isTechnologicalProcessMatch = !filters.technologicalProcess || (!!train.idProcess && train.idProcess === filters.technologicalProcess);
            const isTrainPositionMatch = !filters.trainPosition ||
                (!!train.TrainPosition && train.TrainPosition.toLowerCase().includes(filters.trainPosition.toLowerCase()));
            const isTrainSerialMatch = !filters.trainSerial ||
                (!!train.TrainSerial && train.TrainSerial.toLowerCase().includes(filters.trainSerial.toLowerCase()));
            const isTrainTypeMatch = !filters.trainType ||
                (typeof filters.trainType === "string"
                    ? !!train.TrainType && train.TrainType === Number(filters.trainType.split("system_")[1])
                    : !!train.TrainCustomTypeId && train.TrainCustomTypeId === filters.trainType);
            return (isPathMatch &&
                isEquipmentGroupMatch &&
                isInstanceNumberMatch &&
                isTrainNameMatch &&
                isManufacturerMatch &&
                isRFIDMatch &&
                isTechnologicalProcessMatch &&
                isTrainPositionMatch &&
                isTrainSerialMatch &&
                isTrainTypeMatch);
        };
        this.fillMaxAlarmStatus = (items, considerVisualControlStatus) => {
            return this.fillComputedState(items, considerVisualControlStatus).maxAlarmStatus;
        };
        this.fillParentCategories = () => {
            if (!this.stations || !Array.isArray(this.stations)) {
                return;
            }
            this.stations
                .filter((s) => !s.ParentId)
                .forEach(s => {
                const foundIndex = this.parentsWithoutChildren.findIndex((c) => c.Id === s.Id);
                if (foundIndex !== -1) {
                    this.parentsWithoutChildren[foundIndex].Trains = this.parentsWithoutChildren[foundIndex].Trains.concat(s.Trains.filter(t => t.TrainName && t.TrainId));
                }
                else {
                    this.parentsWithoutChildren.push(Object.assign(Object.assign({}, s), { Trains: s.Trains.filter(t => t.TrainName && t.TrainId), children: [] }));
                }
            });
        };
        this.getSubcategories = (stations, categories) => {
            if (!stations || !Array.isArray(stations)) {
                return [];
            }
            const result = [];
            stations.forEach(s => {
                const foundIndex = categories.findIndex(c => c.Id === s.ParentId);
                if (foundIndex !== -1) {
                    const fountSubcategory = result.find(r => r.Id === s.Id && r.ParentId === s.ParentId);
                    if (!fountSubcategory) {
                        result.push(Object.assign(Object.assign({}, s), { children: [] }));
                    }
                    else {
                        fountSubcategory.Trains = [...fountSubcategory.Trains, ...s.Trains.filter(t => t.TrainName && t.TrainId)];
                    }
                }
            });
            return result;
        };
        this.putChildren = (categories, subcategories) => {
            subcategories.forEach(subcategory => {
                categories.forEach(category => {
                    if (category.Id === subcategory.ParentId) {
                        category.children.push(subcategory);
                    }
                });
            });
            return categories;
        };
        // for debug purposes only to check if all subcategories exists in parents
        this.everyChildExistsInParent = (categories, subcategories) => {
            return subcategories.every((l) => categories.some(p => p.children.find((c) => c.Id === l.Id)));
        };
        this.stations = stations || [];
        this.fillParentCategories();
        this.level2WithoutChildren = this.getSubcategories(this.stations, this.parentsWithoutChildren);
        this.level3WithoutChildren = this.getSubcategories(this.stations, this.level2WithoutChildren);
        this.level4WithoutChildren = this.getSubcategories(this.stations, this.level3WithoutChildren);
        this.level5WithoutChildren = this.getSubcategories(this.stations, this.level4WithoutChildren);
        this.level6WithoutChildren = this.getSubcategories(this.stations, this.level5WithoutChildren);
        this.level7WithoutChildren = this.getSubcategories(this.stations, this.level6WithoutChildren);
        this.level8WithoutChildren = this.getSubcategories(this.stations, this.level7WithoutChildren);
        this.level7 = this.putChildren(this.level7WithoutChildren, this.level8WithoutChildren);
        this.level6 = this.putChildren(this.level6WithoutChildren, this.level7);
        this.level5 = this.putChildren(this.level5WithoutChildren, this.level6);
        this.level4 = this.putChildren(this.level4WithoutChildren, this.level5);
        this.level3 = this.putChildren(this.level3WithoutChildren, this.level4);
        this.level2 = this.putChildren(this.level2WithoutChildren, this.level3);
        this.parents = this.putChildren(this.parentsWithoutChildren, this.level2);
    }
    static MapMenuDataJson(json) {
        return MenuList.MapJson(json);
    }
    static MapJson(json) {
        var _a;
        if (!Array.isArray(json) || json.length === 0) {
            return [];
        }
        if (Array.isArray((_a = json[0]) === null || _a === void 0 ? void 0 : _a.Trains)) {
            return json.map((station) => (Object.assign(Object.assign({}, station), { Trains: station.Trains.map(train => normalizeMenuTrain(train)) })));
        }
        return json.map((e) => ({
            Id: e.id,
            Name: e.n,
            ParentId: e.pid,
            Trains: Array.isArray(e.t) && e.t.length > 0
                ? e.t.map((t) => {
                    var _a, _b;
                    return normalizeMenuTrain({
                        TrainId: t.id,
                        TrainName: t.n,
                        TrainDescription: (_a = t.d) !== null && _a !== void 0 ? _a : null,
                        TrainColour: t.tc,
                        TrainPosition: t.p,
                        TrainSerial: t.s,
                        TrainInstanceNumber: t.in,
                        TrainRFID: t.rf,
                        idManufacturer: t.id_m,
                        idProcess: t.id_p,
                        idEquipmentGroup: t.id_eg,
                        EquipmentGroupPriority: t.egp,
                        TrainCustomTypeId: t.tct,
                        TrainType: t.tt,
                        UserSortNum: t.usn,
                        TciValue: t.ti,
                        ModeColor: t.mc,
                        ModeChangedAt: t.md,
                        ldd: (_b = t.ldd) !== null && _b !== void 0 ? _b : null,
                        Points: { AlarmStatus: t.as, PointStatus: t.ps, VisualControlAlarmStatus: t.vcd },
                    });
                })
                : [
                    normalizeMenuTrain({
                        Points: {},
                    }),
                ],
        }));
    }
    static applySignalingToTrain(target, source) {
        var _a, _b, _c, _d;
        let changed = false;
        const sourcePoint = (_a = source.Points) === null || _a === void 0 ? void 0 : _a[0];
        if (sourcePoint) {
            if (!((_b = target.Points) === null || _b === void 0 ? void 0 : _b.length)) {
                target.Points = [Object.assign({}, sourcePoint)];
                changed = true;
            }
            else {
                const targetPoint = target.Points[0];
                if (targetPoint.AlarmStatus !== sourcePoint.AlarmStatus) {
                    targetPoint.AlarmStatus = sourcePoint.AlarmStatus;
                    changed = true;
                }
                if (targetPoint.PointStatus !== sourcePoint.PointStatus) {
                    targetPoint.PointStatus = sourcePoint.PointStatus;
                    changed = true;
                }
                if (targetPoint.VisualControlAlarmStatus !== sourcePoint.VisualControlAlarmStatus) {
                    targetPoint.VisualControlAlarmStatus = sourcePoint.VisualControlAlarmStatus;
                    changed = true;
                }
            }
        }
        if (source.TciValue !== undefined && target.TciValue !== source.TciValue) {
            target.TciValue = source.TciValue;
            changed = true;
        }
        if (source.ModeColor !== undefined && target.ModeColor !== source.ModeColor) {
            target.ModeColor = source.ModeColor;
            changed = true;
        }
        if (source.ModeChangedAt !== undefined && target.ModeChangedAt !== source.ModeChangedAt) {
            target.ModeChangedAt = source.ModeChangedAt;
            changed = true;
        }
        if (source.ldd !== undefined && target.ldd !== ((_c = source.ldd) !== null && _c !== void 0 ? _c : null)) {
            target.ldd = (_d = source.ldd) !== null && _d !== void 0 ? _d : null;
            changed = true;
        }
        return changed;
    }
    static mergeRecorderSignalingIntoRawList(existing, incoming, windowStart, dbTz) {
        return (0, mergeMenuSignaling_1.mergeRecorderModeMenuSignaling)(existing, incoming, windowStart, dbTz, MenuList.applySignalingToTrain.bind(MenuList));
    }
    static mergeSignalingIntoRawList(existing, incoming) {
        const trainsById = new Map();
        for (const station of incoming) {
            for (const train of station.Trains) {
                if (train.TrainId) {
                    trainsById.set(train.TrainId, train);
                }
            }
        }
        let changed = false;
        for (const station of existing) {
            for (const train of station.Trains) {
                if (!train.TrainId) {
                    continue;
                }
                const sourceTrain = trainsById.get(train.TrainId);
                if (!sourceTrain) {
                    continue;
                }
                if (MenuList.applySignalingToTrain(train, sourceTrain)) {
                    changed = true;
                }
            }
        }
        return changed;
    }
    static mapAutoJsonStation(station) {
        return Object.assign(Object.assign({}, station), { Trains: station.Trains.map(MenuList.mapAutoJsonTrain) });
    }
    static mapAutoJsonTrain(train) {
        var _a, _b;
        const { Tci } = train, rest = __rest(train, ["Tci"]);
        const tci = Tci === null || Tci === void 0 ? void 0 : Tci[0];
        const mode = (_a = tci === null || tci === void 0 ? void 0 : tci.Mode) === null || _a === void 0 ? void 0 : _a[0];
        const points = (_b = rest.Points) !== null && _b !== void 0 ? _b : mode === null || mode === void 0 ? void 0 : mode.Points;
        return Object.assign(Object.assign({}, rest), { TciValue: rest.TciValue !== undefined ? rest.TciValue : tci === null || tci === void 0 ? void 0 : tci.TciValue, ModeColor: rest.ModeColor !== undefined ? rest.ModeColor : mode === null || mode === void 0 ? void 0 : mode.ModeColor, ModeChangedAt: rest.ModeChangedAt !== undefined ? rest.ModeChangedAt : mode === null || mode === void 0 ? void 0 : mode.ModeChangedAt, Points: (points === null || points === void 0 ? void 0 : points.length) ? points : [{}] });
    }
    fillComputedState(items, considerVisualControlStatus) {
        var _a, _b, _c, _d, _e, _f;
        let globalAlarmStatus = null;
        let totalWeightedTciSum = 0;
        let totalTciWeightSum = 0;
        let latestMode = null;
        for (const item of items) {
            let maxAlarmStatus = null;
            let itemWeightedTciSum = 0;
            let itemTciWeightSum = 0;
            let itemLatestMode = null;
            if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) {
                const childState = this.fillComputedState(item.children, considerVisualControlStatus);
                maxAlarmStatus = this.getHigherPriorityAlarmStatus(maxAlarmStatus, childState.maxAlarmStatus);
                itemWeightedTciSum += childState.weightedTciSum;
                itemTciWeightSum += childState.tciWeightSum;
                itemLatestMode = this.getLatestModeCandidate(itemLatestMode, childState.modeChangedAt, childState.modeColor);
            }
            if ((_b = item.Trains) === null || _b === void 0 ? void 0 : _b.length) {
                item.Trains.forEach(train => {
                    maxAlarmStatus = this.getHigherPriorityAlarmStatus(maxAlarmStatus, this.getMaxAlarmStatus(train.Points, considerVisualControlStatus));
                    if (typeof train.TciValue === "number" && !Number.isNaN(train.TciValue)) {
                        const tciWeight = this.getTciWeight(train.EquipmentGroupPriority);
                        itemWeightedTciSum += train.TciValue * tciWeight;
                        itemTciWeightSum += tciWeight;
                    }
                    itemLatestMode = this.getLatestModeCandidate(itemLatestMode, train.ModeChangedAt, train.ModeColor);
                });
            }
            const itemTciValue = itemTciWeightSum > 0 ? Math.trunc(itemWeightedTciSum / itemTciWeightSum) : null;
            const resolvedAlarmStatus = maxAlarmStatus !== null && maxAlarmStatus !== void 0 ? maxAlarmStatus : 255;
            item.MaxAlarmStatus = resolvedAlarmStatus;
            item.TciValue = itemTciValue;
            item.ModeColor = (_c = itemLatestMode === null || itemLatestMode === void 0 ? void 0 : itemLatestMode.modeColor) !== null && _c !== void 0 ? _c : null;
            item.ModeChangedAt = (_d = itemLatestMode === null || itemLatestMode === void 0 ? void 0 : itemLatestMode.modeChangedAt) !== null && _d !== void 0 ? _d : null;
            globalAlarmStatus = this.getHigherPriorityAlarmStatus(globalAlarmStatus, resolvedAlarmStatus);
            totalWeightedTciSum += itemWeightedTciSum;
            totalTciWeightSum += itemTciWeightSum;
            latestMode = this.getLatestModeCandidate(latestMode, item.ModeChangedAt, item.ModeColor);
        }
        const modeColor = (_e = latestMode === null || latestMode === void 0 ? void 0 : latestMode.modeColor) !== null && _e !== void 0 ? _e : null;
        const modeChangedAt = (_f = latestMode === null || latestMode === void 0 ? void 0 : latestMode.modeChangedAt) !== null && _f !== void 0 ? _f : null;
        return {
            maxAlarmStatus: globalAlarmStatus !== null && globalAlarmStatus !== void 0 ? globalAlarmStatus : 255,
            tciValue: totalTciWeightSum > 0 ? Math.trunc(totalWeightedTciSum / totalTciWeightSum) : null,
            weightedTciSum: totalWeightedTciSum,
            tciWeightSum: totalTciWeightSum,
            modeColor,
            modeChangedAt,
        };
    }
    getHigherPriorityAlarmStatus(current, candidate) {
        if (current === null || current === 255) {
            return candidate;
        }
        if (candidate === 255) {
            return current;
        }
        return Math.max(current, candidate);
    }
    getTciWeight(priority) {
        const normalizedPriority = typeof priority === "number" && Number.isFinite(priority) && priority > 0 ? priority : 3;
        return 1 / normalizedPriority;
    }
    getLatestModeCandidate(current, modeChangedAt, modeColor) {
        const timestamp = this.getModeTimestamp(modeChangedAt);
        if (timestamp === null) {
            return current;
        }
        if (!current || timestamp > current.timestamp) {
            return {
                timestamp,
                modeColor: modeColor !== null && modeColor !== void 0 ? modeColor : null,
                modeChangedAt: modeChangedAt,
            };
        }
        return current;
    }
    getModeTimestamp(modeChangedAt) {
        if (!modeChangedAt) {
            return null;
        }
        const timestamp = new Date(modeChangedAt).getTime();
        return Number.isNaN(timestamp) ? null : timestamp;
    }
    getMaxAlarmStatus(Points, considerVisualControlStatus) {
        const point = Points === null || Points === void 0 ? void 0 : Points[0];
        if (!point) {
            return 255;
        }
        const status = point.PointStatus || point.AlarmStatus || (considerVisualControlStatus && point.VisualControlAlarmStatus) || 0;
        if (status !== 0) {
            return status;
        }
        const hasDefinedStatus = point.PointStatus === 0 ||
            point.AlarmStatus === 0 ||
            (considerVisualControlStatus && point.VisualControlAlarmStatus === 0);
        return hasDefinedStatus ? 0 : 255;
    }
}
exports.MenuList = MenuList;
//# sourceMappingURL=menu-list.js.map